import useIsMobile from 'hooks/useIsMobile';
import React from 'react';

import LazyImage from '../LazyImage';

const CSS = require('./ExperienceCardImage.module.scss');

interface ExperienceCardImageProps {
  url: string;
  alt: string;
  visible: boolean;
}

const IMAGE_OPTIONS = {
  xs: { width: 284, height: 160 },
  sm: { width: 385, height: 216 },
};

function ExperienceCardImage({ url, alt, visible }: ExperienceCardImageProps) {
  const isMobile = useIsMobile();
  const imageOptions = isMobile ? IMAGE_OPTIONS.xs : IMAGE_OPTIONS.sm;
  return (
    <>
      {visible && (
        <LazyImage
          animate
          className={CSS.Image}
          src={url}
          alt={alt}
          width={imageOptions.width}
          height={imageOptions.height}
          options={imageOptions}
          loading="lazy"
          containerClass={CSS.ImageFigure}
        />
      )}
      {!visible && <div className={CSS.ImageFigure} />}
    </>
  );
}

export default ExperienceCardImage;
